import React from 'react';
//import { useParams } from 'react-router-dom';
import SEO from '../partials/SEO';
import Header from '../partials/Header';
import StickyHeader from '../partials/StickyHeader';
import Footer from '../partials/Footer';
import About from '../partials/About';
//import Tumblr from '../partials/Tumblr';
import EventList from '../components/events/EventList';
import CoachList from '../components/coaches/CoachList';
import SponsorList from '../components/sponsors/SponsorList';
import RegistrationForm from '../partials/RegistrationForm';

const Home = (props) => {
	//let { slug } = useParams();
	return (
		<div>
			<SEO />
			<Header />
			<StickyHeader />
			{/*<Tumblr />*/}
			<About />
			<EventList />
			<CoachList />
			<RegistrationForm />
			<SponsorList />
			<Footer />
		</div>
	)
}

export default Home;
